<template>

  <div class="activity-title">
    <br/>
    <p>Health, Fitness and Personalized Care in a Community-Based Environment</p>
  </div>

  <div class="activity-grid-container">

    <div class="top-container">
      <div class="top-left-container">
        <div class="grid-title">
          <p>Cultural Engagement</p>
        </div>
        <div>
         <img class="grid-pics" src="../assets/CulturalEngagement.png">
        </div>
        <div class="grid-text">
          <p>We have a strong and diverse cultural network by organizing cultural programs, holiday celebration, and religious activities</p>
        </div>
      </div>

      <div class="top-right-container">
        <div class="grid-title">
          <p>Companionship</p>
        </div>
        <div>
          <img class="grid-pics" src="../assets/Companionship.jpg">
        </div>
        <div class="grid-text">
          <p>Local outings, recreational activities, and group games are designed to ensure a healthy balance of independence and social interaction</p>
        </div>
      </div>
    </div>

    <div class="bottom-container">
      <div class="bottom-left-container">
        <div class="grid-title">
          <p>Continuous Care</p>
        </div>
        <div>
         <img class="grid-pics" src="../assets/ContinuousCare.jpg">
        </div>
        <div class="grid-text">
          <p>Qualified staff is always at hand to nutritious meals, exercise classes, and daily health/medication monitoring</p>
        </div>
      </div>

      <div class="bottom-right-container">
        <div class="grid-title">
          <p>Committed Staff</p>
        </div>
        <div>
          <img class="grid-pics" src="../assets/Staff.jpg">
        </div>
        <div class="grid-text">
          <p>Through counseling services, onsite health monitoring, and door-to-door transportation, we are committed to providing supervised care that meets your individualized needs</p>
        </div>
      </div>
    </div>
  
  </div>
</template>
  
<script>
  export default {
    name: 'ActivitiesBody'
  }
</script>

  
<style scoped>

/* for desktop */
@media (min-width:701px) {

  .activity-title {
    text-align: Center;
    color: darkblue;
    font-style: optima;
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1rem;
    margin-top: -0.6vw;
  }

  .activity-grid-container {
    display: grid;
    grid-template-rows: 1fr 1fr;
    background-color: rgb(238, 238, 238);
  }
  .top-container, .bottom-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background-color: rgb(238, 238, 238);
  }

  .grid-title {
    text-align: Center;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 1.5rem;
    margin-top: 2vw;
  }
  
  .grid-pics {
    width: 28vw;
    height: 22vw;
    border: 5px solid #fff;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.5);
    margin-left: 1.5vw;
  }

  .grid-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: lighter;
    line-height: 1.5rem;
    margin-left: 4.5vw;
    margin-right: 2vw;
  }
}


/* for Phone */
@media (max-width:700px) {

  .activity-title {
    text-align: center;
    font-size: 4vw;
    font-weight: bold;
    color: darkblue;
    margin-top: -3vw;
  }

  .grid-title {
    text-align: center;
    font-size: 3.5vw;
    font-weight: bold;
    color: darkblue;
    margin-bottom: -1vw;
  }
  
  .grid-pics {
    width: 15rem;
    height: 10rem;
  }

  .grid-text {
    text-align: left;
    color: darkblue;
    font-style: optima;
    font-size: 3.5vw;
    height: auto;
    justify-content: top left;
  }
}
</style>